import { useMutation } from '@tanstack/react-query';
import { axiosInstance } from '../../utils';

interface Payload {
  chatId: string;
}

export const getAiChatMessages = async ({ chatId }: Payload): Promise<any> => {
  const res = await axiosInstance.get(`/api/script/get-ai-chats/messages/${chatId}`);
  return res.data;
};

export const useGetAiChatMessages = () => {
  return useMutation(getAiChatMessages, { onSuccess: (data) => data });
};
